import { get } from 'lodash'

export default function(fields = {}, { photoUrl = false, localeId, organizationId }) {
  const person = fields.person || {}
  const address = (person && person.address) || {}

  return {
    id: fields.id,
    person: {
      title: person.title,
      firstName: person.firstName,
      middleName: person.middleName,
      lastName: person.lastName,
      gender: {
        value: get(person, 'gender.value')
      },
      nationality: {
        value: get(person, 'nationality.value')
      },
      employmentStatus: {
        value: get(person, 'employmentStatus.value')
      },
      birthDate: person.birthDate,
      email: person.email,
      userName: person.userName,
      locale: {
        id: localeId
      },
      userAccountId: person.userAccountId,
      organizationMember: person.organizationMember,
      awardLeader: person.awardLeader,
      contacts: [...person.contacts],
      address: {
        id: address.id,
        line1: address.line1,
        line2: address.line2,
        city: address.city,
        state: address.state,
        zipCode: address.zipCode,
        country: {
          id: get(address, 'country.id')
        },
        region: {
          id: get(address, 'region.id')
        }
      },
      photoUrl: photoUrl || get(person, 'photoUrl')
    },
    userRegistrationAssessmentState: fields.userRegistrationAssessmentState,
    parentFirstName: fields.parentFirstName,
    parentLastName: fields.parentLastName,
    parentPhone: fields.parentPhone,
    parentEmail: fields.parentEmail,
    parentRelationship: fields.parentRelationship,
    consentDeliveryType: fields.consentDeliveryType,
    previousCompletedAwardPlace: fields.previousCompletedAwardPlace,
    paymentState: fields.paymentState,
    state: fields.state,
    awards: [{
      awardLeader: {
        id: get(fields, 'awards[0].awardLeader.id')
      },
      organization: {
        id: get(fields, 'awards[0].organization.id') || organizationId
      },
      awardLevel: {
        value: get(fields, 'awards[0].awardLevel.value')
      }
    }]
  }
}
